export default __webpack_public_path__ + "static/teamPhoto4-5b5c48228b7d8ab08eb31fe04c27a38f.png";